module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-photo-4-010bfe8cd471f72d76e6151bdb6c66a3.jpg";